// @flow

import * as React from 'react';
import { Link } from 'react-router-dom';

export const BASE =
  (__CLIENT__ &&
    (() => {
      try {
        const base = document.querySelector('base[href]').getAttribute('href');
        if (base !== document.location.origin) {
          return base;
        }
      } catch (e) {}
      return '';
    })()) ||
  '';

const LinkWithBase = props => {
  if (BASE) {
    const { to, children, ...rest } = props;
    return (
      <a {...rest} href={`${BASE}${to}`}>
        {children}
      </a>
    );
  }
  return <Link {...props} />;
};

export default LinkWithBase;
